export default __webpack_public_path__ + "static/media/home_company.2f295b17.svg";